import style from './css'

const singlePageFlow = {
  label: 'Single page flow',
  includeInShowcase: true,
  config: {
    userId: 'PayTestGB',
    merchantId: 198003,
    tabs: true,
    singlePageFlow: true,
    showHeader: false,
    logoFullWidth: true
  },
  theme: {
    input: {
      height: '52px'
    },
    buttons: {
      color: '#000000'
    },
    labels: {
      color: '#7d7d7d'
    },
    background: {
      color: '#fafbfc'
    },
    loader: {
      color: '#000000'
    }
  },
  style
}

const singlePageFlowPage = {
  ...singlePageFlow,
  includeInShowcase: true,
  label: 'Single page flow (page)',
  display: 'page',
  config: {
    ...singlePageFlow.config,
    logoUrl: 'https://static.paymentiq.io/worldline-logo.svg'
  },
  theme: {
    headerbackground: {
      color: '#e5e5e5'
    }
  }
}

export default {
  singlePageFlow,
  singlePageFlowPage
}
